import { Injectable } from '@angular/core';
import { PouchdbService } from '../../../shared/pouchDb.service';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class ExportService {
    localDB; remoteDB;

    constructor(public pouchService: PouchdbService) {
        this.localDB = pouchService.localDB;
    }

    private closeGlobalExport = new BehaviorSubject<any>([]);
    closeGlobalExport$ = this.closeGlobalExport.asObservable();


    getPageContent(id, contentdoc, scope) {



        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'pageContent', _id: id },
        }).then(function (result) {
            if (result.docs.length > 0) {

                contentdoc.pageContent = result.docs[0].pageContent
                scope.updatePageContent(contentdoc);

                // resolve(contentdoc);
            }

            else {

                // scope.openSnackBar('There is nothing to export', '');
            }
        }).catch(function (err) {

        });


    }


    updateExportToPouchdb(document) {

        var self = this;
        self.pouchService.localDB.put(document).then(function (response) {
            console.log(response);
            // self.getPages(bookObj,"","");

            self.pouchService.replicateExportDoc(response.id);


        }).catch(function (err) {
            console.log(err);
        });
    }

    closeExport() {

        this.closeGlobalExport.next('close');
    }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/export/exoprt.service.ts